import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
// import { ColorPickerModule } from 'ngx-color-picker';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { EppColorPickerModule } from '../epp-color-picker/epp-color-picker.module';
import { XcHelp2Module } from '../help2/help2.module';
import { CeArrayComponent } from './ce-array/ce-array.component';
import { CeItemComponent } from './ce-item/ce-item.component';
import { ConfigEditor2Component } from './config-editor2.component';
import { I18nInputModule } from './i18n-input/i18n-input.module';

@NgModule({
  declarations: [
    ConfigEditor2Component,
    CeArrayComponent,
    CeItemComponent,
  ],
  imports: [
    CommonModule,
    NzAutocompleteModule,
    NzDropDownModule,
    // NzModalModule,
    FormsModule,
    ReactiveFormsModule,
    // ColorPickerModule,
    AccordionModule,
    TranslateModule,
    I18nInputModule,
    EppColorPickerModule,
    // HelpModule,
    NzToolTipModule,
    NzSwitchModule,
    NzSelectModule,
    XcHelp2Module,
  ],
  exports: [
    ConfigEditor2Component,
    CeArrayComponent,
    CeItemComponent,
  ]
})
export class ConfigEditor2Module { }
